import { TextField } from "@mui/material"

export function NoValueNeeded({ operator }) {
    return (
        <TextField size="small" disabled fullWidth value={operator || ""} placeholder="Operator determines the value" />
    )
}
